import * as React from 'react';
import { SelectProps } from '../Provider';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Checkbox,
  ThemeProvider,
  createTheme,
} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import { useAppSelector } from '../../../hooks';
import { selectTheme } from '../../../slices/global/themeSlice';

interface Props {
  select: SelectProps;
}

const SelectDialog = ({ select }: Props) => {
  const { open, title, options, proceed, reject, isMultiple, canClose } = select;
  const mode = useAppSelector(selectTheme);

  const darkTheme = createTheme({
    palette: {
      mode: mode,
    },
  });
  const [value, setValue] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (!open) setValue([]);
  }, [open]);

  return (
    <ThemeProvider theme={darkTheme}>
      <Dialog
        open={open}
        onClose={(_, reason: string) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown' || !reject) return;
          reject();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select one of the following options for {title}:{' '}
            <strong>
              <u>{value.join(', ')}</u>
            </strong>
          </DialogContentText>
          <FormControl sx={{ maxHeight: 500, overflow: 'auto', width: '100%' }}>
            <FormGroup>
              {options.map((option, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={value.includes(option)}
                      onChange={(e) => {
                        setValue((prevValue) => {
                          var index = prevValue.findIndex((x) => x === e.target.name);
                          if (isMultiple) {
                            if (index === -1) {
                              prevValue.push(e.target.name);
                            } else {
                              prevValue.splice(index, 1);
                            }
                          } else {
                            prevValue = [e.target.name];
                          }
                          return [...prevValue];
                        });
                      }}
                      name={option}
                    />
                  }
                  label={option}
                />
              ))}
            </FormGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          {canClose && (
            <Button
              onClick={() => {
                if (reject) reject();
              }}
            >
              Cancel
            </Button>
          )}
          <Button
            autoFocus
            disabled={options.length === 0 || value.length === 0}
            onClick={() => {
              if (proceed) proceed(value);
            }}
          >
            Select
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default SelectDialog;
